// import React, { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
// import { getAuth, onAuthStateChanged } from 'firebase/auth';
// import {
//   getCustomerByPhone,
//   createCustomer,
//   addTransaction,
//   getTransactions,
//   getAllCustomers,
//   getTotalStats,
//   getRewardTiers,
//   getPromotion,
//   getRedemptionHistory,
//   getAppSettings,
//   getStaffMembers,
//   getMonthlyPointsData
// } from './firebase';
// import './i18n/i18n.js'; // Import the i18n configuration
// import LanguageProvider from './components/LanguageProvider';
// import LanguageSwitcher from './components/LanguageSwitcher';
// import CVComponent from './components/cv.js';
// import './App.css';

// // Components
// import Sidebar from './components/Sidebar';
// import Header from './components/Header';
// import Dashboard from './pages/Dashboard';
// import CustomerManagement from './pages/CustomerManagement';
// import TransactionsPage from './pages/TransactionsPage';
// import RewardsManagement from './pages/RewardsManagement';
// import SettingsPage from './pages/SettingsPage';
// import CustomerKiosk from './pages/CustomerKiosk';
// import SendSmsPage from './pages/SendSmsPage';
// import LoginPage from './pages/loginPage.js';

// // Main App Container
// const AppContainer = () => {
//   return (
//     <LanguageProvider>
//       <Router>
//         <AppRoutes />
//       </Router>
//     </LanguageProvider>
//   );
// };

// // Application Routes
// const AppRoutes = () => {
//   const [user, setUser] = useState(null);
//   const [authLoading, setAuthLoading] = useState(true);

//   useEffect(() => {
//     const auth = getAuth();
//     const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
//       setUser(currentUser);
//       setAuthLoading(false);
//     });

//     return () => unsubscribe();
//   }, []);

//   if (authLoading) {
//     return (
//       <div className="loading-screen">
//         تحميل
//       </div>
//     );
//   }

//   return (
//     <Routes>
//       {/* Public routes */}
//       <Route path="/login" element={!user ? <LoginPage /> : <Navigate to="/customers" />} />
//       <Route path="/kiosk" element={<CustomerKiosk />} />

//       {/* Protected routes */}
//       <Route path="/*" element={user ? <AdminApp /> : <Navigate to="/login" />} />
//     </Routes>
//   );
// };

// // Your original App component, now as a child component
// const AdminApp = () => {
//   // Navigation state
//   const [currentPage, setCurrentPage] = useState('customers');
//   const navigate = useNavigate();

//   // Customer and transaction state
//   const [customer, setCustomer] = useState(null);
//   const [customers, setCustomers] = useState([]);
//   const [transactions, setTransactions] = useState([]);

//   // UI state
//   const [loading, setLoading] = useState(false);
//   const [notification, setNotification] = useState(null);
//   const [error, setError] = useState('');

//   // Dashboard data
//   const [stats, setStats] = useState({
//     totalCustomers: 0,
//     totalPoints: 0,
//     totalTransactions: 0,
//     averagePoints: 0
//   });
//   const [monthlyPointsData, setMonthlyPointsData] = useState([]);

//   // Rewards data
//   const [rewardTiers, setRewardTiers] = useState([]);
//   const [promotions, setPromotions] = useState([]);
//   const [redemptionHistory, setRedemptionHistory] = useState([]);

//   // Settings data
//   const [appSettings, setAppSettings] = useState({});
//   const [staffMembers, setStaffMembers] = useState([]);

//   const [selectedCustomer, setSelectedCustomer] = useState(null);

//   // Handle logout
//   const handleLogout = () => {
//     const auth = getAuth();
//     auth.signOut()
//       .then(() => {
//         navigate('/login');
//       })
//       .catch((error) => {
//         console.error('Logout error:', error);
//       });
//   };

//   // Update URL when currentPage changes
//   useEffect(() => {
//     if (currentPage === 'dashboard') {
//       navigate('/dashboard');
//     } else {
//       navigate(`/${currentPage}`);
//     }
//   }, [currentPage, navigate]);

//   // Update currentPage when URL changes
//   useEffect(() => {
//     const path = window.location.pathname.substring(1) || 'customers';
//     const validPages = ['dashboard', 'customers', 'transactions', 'rewards', 'settings', 'sendsms'];
//     if (validPages.includes(path)) {
//       setCurrentPage(path);
//     }
//   }, []);

//   // Load initial data when the app starts
//   useEffect(() => {
//     fetchStats();
//     fetchAllCustomers();

//     // Auto-refresh data periodically (every 5 minutes)
//     const refreshInterval = setInterval(() => {
//       if (currentPage === 'dashboard') {
//         fetchStats();
//         fetchAllCustomers();
//       }
//     }, 300000);

//     return () => clearInterval(refreshInterval);
//   }, []);

//   // Load page-specific data when page changes
//   useEffect(() => {
//     switch(currentPage) {
//       case 'dashboard':
//         fetchStats();
//         fetchAllCustomers();
//         fetchMonthlyData();
//         break;
//       case 'rewards':
//         fetchRewardsData();
//         break;
//       case 'settings':
//         fetchSettingsData();
//         break;
//       default:
//         break;
//     }
//   }, [currentPage]);

//   // Dashboard data fetching
//   const fetchStats = async () => {
//     try {
//       setLoading(true);
//       const statsData = await getTotalStats();
//       setStats(statsData);
//     } catch (err) {
//       console.error("Error fetching stats:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchAllCustomers = async () => {
//     try {
//       setLoading(true);
//       const customersData = await getAllCustomers();
//       setCustomers(customersData);
//     } catch (err) {
//       console.error("Error fetching customers:", err);
//       setError('Failed to load customers');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchMonthlyData = async () => {
//     try {
//       const chartData = await getMonthlyPointsData();
//       setMonthlyPointsData(chartData);
//     } catch (err) {
//       console.error("Error fetching monthly data:", err);
//     }
//   };

//   // Customer and transaction operations
//   const searchCustomer = async (phoneNumber) => {
//     if (!phoneNumber.trim()) {
//       setError('Please enter a phone number');
//       return null;
//     }

//     try {
//       setLoading(true);
//       setError('');
//       const foundCustomer = await getCustomerByPhone(phoneNumber);

//       if (foundCustomer) {
//         setCustomer(foundCustomer);
//         const customerTransactions = await getTransactions(phoneNumber);
//         setTransactions(customerTransactions);
//         return foundCustomer;
//       } else {
//         setCustomer(null);
//         setTransactions([]);
//         return null;
//       }
//     } catch (err) {
//       setError('Error searching for customer: ' + err.message);
//       return null;
//     } finally {
//       setLoading(false);
//     }
//   };

//   const registerCustomer = async (phoneNumber, customerData) => {
//     if (!customerData.name || !customerData.city || !customerData.amount) {
//       setError('All fields are required');
//       return null;
//     }

//     try {
//       setLoading(true);
//       const createdCustomer = await createCustomer(phoneNumber, customerData);
//       setCustomer(createdCustomer);
//       const customerTransactions = await getTransactions(phoneNumber);
//       setTransactions(customerTransactions);

//       // Show notification
//       const pointsEarned = parseInt(customerData.amount) * (customerData.pointsPerDollar || 10);
//       setNotification({
//         message: `Customer ${customerData.name} registered! Earned ${pointsEarned} points on first purchase.`,
//         isThreshold: pointsEarned >= 1000
//       });

//       // Refresh stats and customer list
//       fetchStats();
//       fetchAllCustomers();

//       return createdCustomer;
//     } catch (err) {
//       setError('Error registering customer: ' + err.message);
//       return null;
//     } finally {
//       setLoading(false);
//     }
//   };

//   const addPurchase = async (phoneNumber, amount, multiplier = 1, pointsPerDollar = 1) => {
//     if (!amount) {
//       setError('Please enter purchase amount');
//       return null;
//     }

//     try {
//       setLoading(true);
//       // Pass the multiplier to the addTransaction function
//       const result = await addTransaction(phoneNumber, amount, multiplier, pointsPerDollar);
//       setCustomer(result.customer);
//       const customerTransactions = await getTransactions(phoneNumber);
//       setTransactions(customerTransactions);

//       // Show notification
//       setNotification({
//         message: `Transaction recorded! Customer earned ${result.pointsEarned} points.`,
//         isThreshold: result.reachedThreshold
//       });

//       // Refresh stats
//       fetchStats();

//       return result;
//     } catch (err) {
//       setError('Error adding purchase: ' + err.message);
//       return null;
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Rewards management
//   const fetchRewardsData = async () => {
//     try {
//       setLoading(true);
//       // Fetch reward tiers
//       const tiers = await getRewardTiers();
//       setRewardTiers(tiers);

//       // Fetch promotions
//       const promos = await getPromotion();
//       setPromotions(promos);

//       // Fetch redemption history
//       const redemptionData = await getRedemptionHistory();
//       setRedemptionHistory(redemptionData.history);
//     } catch (err) {
//       console.error("Error fetching rewards data:", err);
//       setError("Failed to load rewards data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Settings management
//   const fetchSettingsData = async () => {
//     try {
//       setLoading(true);
//       // Fetch settings
//       const settings = await getAppSettings();
//       setAppSettings(settings);

//       // Fetch staff members
//       const staff = await getStaffMembers();
//       setStaffMembers(staff);
//     } catch (err) {
//       console.error("Error fetching settings:", err);
//       setError("Failed to load settings");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Clear notification after 5 seconds
//   useEffect(() => {
//     if (notification) {
//       const timer = setTimeout(() => {
//         setNotification(null);
//       }, 5000);
//       return () => clearTimeout(timer);
//     }
//   }, [notification]);

//   // Render different pages based on route
//   const renderPage = (page) => {
//     switch(page) {
//       case 'dashboard':
//         return <Dashboard
//                  stats={stats}
//                  recentCustomers={customers.slice(0, 5)}
//                  loading={loading}
//                  monthlyPointsData={monthlyPointsData}
//                />;
//       case 'customers':
//         return <CustomerManagement
//                  customers={customers}
//                  onSearchCustomer={searchCustomer}
//                  onRegisterCustomer={registerCustomer}
//                  onAddPurchase={addPurchase}
//                  selectedCustomer={customer}
//                  transactions={transactions}
//                  loading={loading}
//                />;
//       case 'transactions':
//         return <TransactionsPage />;
//       case 'rewards':
//         return <RewardsManagement
//                  rewardTiers={rewardTiers}
//                  promotions={promotions}
//                  redemptionHistory={redemptionHistory}
//                  loading={loading}
//                  onFetchData={fetchRewardsData}
//                />;
//       case 'sendsms':  // Case for Send SMS page
//                return <SendSmsPage />;
//       case 'settings':
//         return <CVComponent />;
//       default:
//         return <Dashboard
//                  stats={stats}
//                  recentCustomers={customers.slice(0, 5)}
//                  loading={loading}
//                  monthlyPointsData={monthlyPointsData}
//                />;
//     }
//   };

//   return (
//     <div className="app-wrapper">
//       <Sidebar
//         currentPage={currentPage}
//         setCurrentPage={setCurrentPage}
//       />

//       <div className="content-wrapper">
//         <Header
//           notification={notification}
//           error={error}
//           clearError={() => setError('')}
//           onLogout={handleLogout}
//         >
//           <LanguageSwitcher />
//         </Header>

//         <main className="main-content">
//           <Routes>
//             <Route path="/" element={renderPage('dashboard')} />
//             <Route path="/dashboard" element={renderPage('dashboard')} />
//             <Route path="/customers" element={renderPage('customers')} />
//             <Route path="/transactions" element={renderPage('transactions')} />
//             <Route path="/rewards" element={renderPage('rewards')} />
//             <Route path="/sendsms" element={renderPage('sendsms')} />
//             <Route path="/settings" element={renderPage('settings')} />
//             <Route path="*" element={renderPage('dashboard')} />
//           </Routes>
//         </main>
//       </div>
//     </div>
//   );
// };

// // Export the container component
// export default AppContainer;

import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import {
  getCustomerByPhone,
  createCustomer,
  addTransaction,
  getTransactions,
  getAllCustomers,
  getTotalStats,
  getRewardTiers,
  getPromotion,
  getRedemptionHistory,
  getAppSettings,
  getStaffMembers,
  getMonthlyPointsData,
} from "./firebase";
import "./i18n/i18n.js"; // Import the i18n configuration
import LanguageProvider from "./components/LanguageProvider";
import LanguageSwitcher from "./components/LanguageSwitcher";
import CVComponent from "./components/cv.js";
import "./App.css";

// Components
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import Dashboard from "./pages/Dashboard";
import CustomerManagement from "./pages/CustomerManagement";
import TransactionsPage from "./pages/TransactionsPage";
import RewardsManagement from "./pages/RewardsManagement";
import SettingsPage from "./pages/SettingsPage";
import CustomerKiosk from "./pages/CustomerKiosk";
import SendSmsPage from "./pages/SendSmsPage";
import LoginPage from "./pages/loginPage.js";
import { useTranslation } from "react-i18next";
// Protected Route Component
const ProtectedRoute = ({ children, adminOnly }) => {
  const location = useLocation();
  const isAdmin = localStorage.getItem("isAdmin") === "true";

  // If the route is admin-only and user is not admin, redirect to customers
  if (adminOnly && !isAdmin) {
    return <Navigate to="/customers" replace />;
  }

  return children;
};

// Main App Container
const AppContainer = () => {
  return (
    <LanguageProvider>
      <Router>
        <AppRoutes />
      </Router>
    </LanguageProvider>
  );
};

// Application Routes
const AppRoutes = () => {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setAuthLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (authLoading) {
    return <div className="loading-screen">Loading...</div>;
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route
        path="/login"
        element={!user ? <LoginPage /> : <Navigate to="/customers" />}
      />
      <Route path="/kiosk" element={<CustomerKiosk />} />

      {/* Protected routes */}
      <Route
        path="/*"
        element={user ? <AdminApp /> : <Navigate to="/login" />}
      />
    </Routes>
  );
};

// Your original App component, now as a child component
const AdminApp = () => {
  const { t } = useTranslation();
  // Navigation state
  const [currentPage, setCurrentPage] = useState("customers");
  const navigate = useNavigate();
  const isAdmin = localStorage.getItem("isAdmin") === "true";

  // Customer and transaction state
  const [customer, setCustomer] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [transactions, setTransactions] = useState([]);

  // UI state
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);
  const [error, setError] = useState("");

  // Dashboard data
  const [stats, setStats] = useState({
    totalCustomers: 0,
    totalPoints: 0,
    totalTransactions: 0,
    averagePoints: 0,
  });
  const [monthlyPointsData, setMonthlyPointsData] = useState([]);

  // Rewards data
  const [rewardTiers, setRewardTiers] = useState([]);
  const [promotions, setPromotions] = useState([]);
  const [redemptionHistory, setRedemptionHistory] = useState([]);

  // Settings data
  const [appSettings, setAppSettings] = useState({});
  const [staffMembers, setStaffMembers] = useState([]);

  const [selectedCustomer, setSelectedCustomer] = useState(null);

  // Handle logout
  const handleLogout = () => {
    const auth = getAuth();
    auth
      .signOut()
      .then(() => {
        localStorage.removeItem("isAdmin");
        navigate("/login");
      })
      .catch((error) => {
        console.error("Logout error:", error);
      });
  };
  const handlePageChange = (page) => {
    // Only reset customer data if navigating away from customers page
    if (currentPage === "customers" && page !== "customers") {
      setCustomer(null);
      setTransactions([]);
    }

    setCurrentPage(page);
  };

  // Get filtered sidebar items based on admin status
  const getFilteredMenuItems = () => {
    // All menu items
    const allItems = [
      { id: "customers", label: t("nav.customers"), icon: "👥" },
      //{ id: "dashboard", label: t("nav.dashboard"), icon: "📊" },
      { id: "transactions", label: t("nav.transactions"), icon: "💳" },
      { id: "rewards", label: t("nav.rewards"), icon: "🎁" },
      { id: "sendsms", label: "ارسال رسائل", icon: "✉️" },
    ];

    // For non-admin users, only show customers
    if (!isAdmin) {
      return allItems.filter(
        (item) => item.id === "customers" || item.id === "sendsms"
      );
    }

    // Admin gets all items
    return allItems;
  };

  // Update URL when currentPage changes
  useEffect(() => {
    // Regular users should only navigate to customers or sendsms
    if (!isAdmin && currentPage !== "customers" && currentPage !== "sendsms") {
      setCurrentPage("customers");
      navigate("/customers");
      return;
    }

    if (currentPage === "customers") {
      navigate("/customers");
    } else {
      navigate(`/${currentPage}`);
    }
  }, [currentPage, navigate, isAdmin]);

  // Update currentPage when URL changes
  useEffect(() => {
    const path = window.location.pathname.substring(1) || "dashboard";
    const validPages = [
      "customers",
      "transactions",
      "rewards",
      "settings",
      "sendsms",
    ];

    if (validPages.includes(path)) {
      // Non-admin users can only access customers and sendsms pages
      if (!isAdmin && path !== "customers" && path !== "sendsms") {
        setCurrentPage("customers");
        navigate("/customers");
      } else {
        setCurrentPage(path);
      }
    }
  }, [isAdmin]);

  // Load initial data when the app starts
  useEffect(() => {
    fetchStats();
    fetchAllCustomers();

    // Auto-refresh data periodically (every 5 minutes)
    const refreshInterval = setInterval(() => {
      if (currentPage === "dashboard") {
        fetchStats();
        fetchAllCustomers();
      }
    }, 300000);

    return () => clearInterval(refreshInterval);
  }, []);

  // Load page-specific data when page changes
  useEffect(() => {
    switch (currentPage) {
      case "dashboard":
        fetchStats();
        fetchAllCustomers();
        fetchMonthlyData();
        break;
      case "rewards":
        fetchRewardsData();
        break;
      case "settings":
        fetchSettingsData();
        break;
      default:
        break;
    }
  }, [currentPage]);

  // [Keep all your existing functions from the original AdminApp component]
  // Dashboard data fetching
  const fetchStats = async () => {
    try {
      setLoading(true);
      const statsData = await getTotalStats();
      setStats(statsData);
    } catch (err) {
      console.error("Error fetching stats:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllCustomers = async () => {
    try {
      setLoading(true);
      const customersData = await getAllCustomers();
      setCustomers(customersData);
    } catch (err) {
      console.error("Error fetching customers:", err);
      setError("Failed to load customers");
    } finally {
      setLoading(false);
    }
  };

  const fetchMonthlyData = async () => {
    try {
      const chartData = await getMonthlyPointsData();
      setMonthlyPointsData(chartData);
    } catch (err) {
      console.error("Error fetching monthly data:", err);
    }
  };

  // Customer and transaction operations
  const searchCustomer = async (phoneNumber) => {
    if (!phoneNumber.trim()) {
      setError("Please enter a phone number");
      return null;
    }

    try {
      setLoading(true);
      setError("");
      const foundCustomer = await getCustomerByPhone(phoneNumber);

      if (foundCustomer) {
        setCustomer(foundCustomer);
        const customerTransactions = await getTransactions(phoneNumber);
        setTransactions(customerTransactions);
        return foundCustomer;
      } else {
        setCustomer(null);
        setTransactions([]);
        return null;
      }
    } catch (err) {
      setError("Error searching for customer: " + err.message);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const registerCustomer = async (phoneNumber, customerData) => {
    if (!customerData.name || !customerData.city || !customerData.amount) {
      setError("All fields are required");
      return null;
    }

    try {
      setLoading(true);
      const createdCustomer = await createCustomer(phoneNumber, customerData);
      setCustomer(createdCustomer);
      const customerTransactions = await getTransactions(phoneNumber);
      setTransactions(customerTransactions);

      // Show notification
      const pointsEarned =
        parseInt(customerData.amount) * (customerData.pointsPerDollar || 10);
      setNotification({
        message: `Customer ${customerData.name} registered! Earned ${pointsEarned} points on first purchase.`,
        isThreshold: pointsEarned >= 1000,
      });

      // Refresh stats and customer list
      fetchStats();
      fetchAllCustomers();

      return createdCustomer;
    } catch (err) {
      setError("Error registering customer: " + err.message);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const addPurchase = async (
    phoneNumber,
    amount,
    multiplier = 1,
    pointsPerDollar = 1,
    employeeName = '', // Add employeeName parameter
    category = ''
  ) => {
    if (!amount) {
      setError("Please enter purchase amount");
      return null;
    }
  
    try {
      setLoading(true);
      // Pass the multiplier AND employeeName to the addTransaction function
      const result = await addTransaction(
        phoneNumber,
        amount,
        multiplier,
        pointsPerDollar,
        employeeName, // Pass employeeName to addTransaction
        category
      );
      setCustomer(result.customer);
      const customerTransactions = await getTransactions(phoneNumber);
      setTransactions(customerTransactions);
  
      // Show notification
      setNotification({
        message: `Transaction recorded! Customer earned ${result.pointsEarned} points.`,
        isThreshold: result.reachedThreshold,
      });
  
      // Refresh stats
      fetchStats();
  
      return result;
    } catch (err) {
      setError("Error adding purchase: " + err.message);
      return null;
    } finally {
      setLoading(false);
    }
  };

  // Rewards management
  const fetchRewardsData = async () => {
    try {
      setLoading(true);
      // Fetch reward tiers
      const tiers = await getRewardTiers();
      setRewardTiers(tiers);

      // Fetch promotions
      const promos = await getPromotion();
      setPromotions(promos);

      // Fetch redemption history
      const redemptionData = await getRedemptionHistory();
      setRedemptionHistory(redemptionData.history);
    } catch (err) {
      console.error("Error fetching rewards data:", err);
      setError("Failed to load rewards data");
    } finally {
      setLoading(false);
    }
  };

  // Settings management
  const fetchSettingsData = async () => {
    try {
      setLoading(true);
      // Fetch settings
      const settings = await getAppSettings();
      setAppSettings(settings);

      // Fetch staff members
      const staff = await getStaffMembers();
      setStaffMembers(staff);
    } catch (err) {
      console.error("Error fetching settings:", err);
      setError("Failed to load settings");
    } finally {
      setLoading(false);
    }
  };

  // Clear notification after 5 seconds
  useEffect(() => {
    if (notification) {
      const timer = setTimeout(() => {
        setNotification(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [notification]);

  // Render different pages based on route
  const renderPage = (page) => {
    switch (page) {
      case "dashboard":
        return (
          <Dashboard
            stats={stats}
            recentCustomers={customers.slice(0, 5)}
            loading={loading}
            monthlyPointsData={monthlyPointsData}
          />
        );
      case "customers":
        return (
          <CustomerManagement
            customers={customers}
            onSearchCustomer={searchCustomer}
            onRegisterCustomer={registerCustomer}
            onAddPurchase={addPurchase}
            selectedCustomer={customer}
            transactions={transactions}
            loading={loading}
          />
        );
      case "transactions":
        return <TransactionsPage />;
      case "rewards":
        return (
          <RewardsManagement
            rewardTiers={rewardTiers}
            promotions={promotions}
            redemptionHistory={redemptionHistory}
            loading={loading}
            onFetchData={fetchRewardsData}
          />
        );
      case "sendsms":
        return <SendSmsPage />;
      case "settings":
        return <CVComponent />;
      default:
        return (
          <Dashboard
            stats={stats}
            recentCustomers={customers.slice(0, 5)}
            loading={loading}
            monthlyPointsData={monthlyPointsData}
          />
        );
    }
  };

  return (
    <div className="app-wrapper">
      <Sidebar
        currentPage={currentPage}
        setCurrentPage={handlePageChange} // Use the new function instead
        menuItems={getFilteredMenuItems()}
      />

      <div className="content-wrapper">
        <Header
          notification={notification}
          error={error}
          clearError={() => setError("")}
          onLogout={handleLogout}
        >
          <LanguageSwitcher />
        </Header>

        <main className="main-content">
          <Routes>
            <Route
              path="/"
              element={
                <ProtectedRoute adminOnly={true}>
                  {renderPage("dashboard")}
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute adminOnly={true}>
                  {renderPage("dashboard")}
                </ProtectedRoute>
              }
            />
            <Route path="/customers" element={renderPage("customers")} />
            <Route
              path="/transactions"
              element={
                <ProtectedRoute adminOnly={true}>
                  {renderPage("transactions")}
                </ProtectedRoute>
              }
            />
            <Route
              path="/rewards"
              element={
                <ProtectedRoute adminOnly={true}>
                  {renderPage("rewards")}
                </ProtectedRoute>
              }
            />
            <Route path="/sendsms" element={renderPage("sendsms")} />
            <Route
              path="/settings"
              element={
                <ProtectedRoute adminOnly={true}>
                  {renderPage("settings")}
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/customers" replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default AppContainer;
